import { render, staticRenderFns } from "./DigitalFormList.vue?vue&type=template&id=3473bae4&scoped=true&"
import script from "./DigitalFormList.vue?vue&type=script&lang=js&"
export * from "./DigitalFormList.vue?vue&type=script&lang=js&"
import style0 from "./DigitalFormList.vue?vue&type=style&index=0&id=3473bae4&prod&lang=scss&scoped=true&"
import style1 from "./DigitalFormList.vue?vue&type=style&index=1&id=3473bae4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473bae4",
  null
  
)

export default component.exports